<div [class]="getClasses()">
  <ng-content />
</div>
